import { Link } from "react-router-dom";
const date = new Date();
const year = date.getFullYear();

const AccountFooter = () => {
  return (
    <footer className="bg-light text-center text-lg-start">
      <div
        className="text-center p-3"
        style={{ backgroundColor: "rgba(0, 0, 0, 0.2);" }}
      >
        &copy; {year} Copyright:{" "}
        <Link className="text-dark" to="/">
          App.DrugStoc.com
        </Link>
      </div>
    </footer>
  );
};

export default AccountFooter;
